//
//
//
//
//
//

    import ClipboardJS from "clipboard";
    export default {
        name: 'window',
        data: () => {},
        mounted() {
            this.init()
        },
        methods: {}
    }




// WEBPACK FOOTER //
// ./src/page/miniUrl/window.vue